import { Col, Flex, Typography } from "antd";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useState } from "react";
import { executeBid } from "services";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { parseErrorMessage } from "utils";

export const ExecuteBidModal = observer(() => {
  const { actionModals, bidCard } = useStores();
  const { openNotification } = useNotificationContext();

  const { id: bidId } = bidCard.bid;

  const [loading, setLoading] = useState(false);

  const handleCloseModal = () => {
    actionModals.closeAll();
  };

  const executeBidHandler = async () => {
    setLoading(true);

    await executeBid({ id: bidId })
      .then(() => {
        handleCloseModal();
        openNotification({
          message: "Отправлено успешно",
          type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        });
        // setTimeout(() => {
        //   window.updateOnboardingElements?.();
        // }, 1000);
      })
      .catch((e) => {
        openNotification({
          description: parseErrorMessage(e),
          type: NOTIFICATION_TYPE_ENUM.ERROR,
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <Flex vertical gap="large">
      <Flex vertical gap="middle">
        <Typography.Text>
          В исполнение заявки ЦВ с транзитного кошелька будет переведена на адрес получателя.
        </Typography.Text>
      </Flex>
      <Flex gap="large">
        <Col>
          <CustomButton loading={loading} disabled={loading} onClick={() => executeBidHandler()}>
            Подтвердить действие
          </CustomButton>
        </Col>
        <Col>
          <CustomButton variant="outlined" loading={loading} disabled={loading} onClick={handleCloseModal}>
            Отмена
          </CustomButton>
        </Col>
      </Flex>
    </Flex>
  );
});
